import { Sprout } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const FoundingBadge = ({ dark = false, className = "", testId = "founding-badge" }) => {
  const { user } = useAuth();
  if (!user?.founding_member && !user?.beta_tester) return null;
  const tester = user.beta_tester || user.founding_reason === "beta";
  const title = tester ? "One of the first founders to test The Roots Club" : "Joined with the founding member offer";
  return (
    <span title={title} data-testid={testId}
      className={`founding-badge inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-mono uppercase tracking-[0.15em] ${dark ? "bg-sun text-navy" : "bg-navy text-sun"} ${className}`}>
      <Sprout className="h-3.5 w-3.5" />{tester ? "Founding beta tester" : "Founding member"}
    </span>
  );
};
